import {
  SWITCH_LANGUAGE,
  TOGGLE_COLLAPSED_NAV,
  TOGGLE_COLLAPSED_LANG,
  SET_MENU_FOOTER_ACTIVE,
  TOGGLE_COLLAPSED_MEMBER_MENU,
  COLLAPSED_ALL_MENU,
} from "../actions/types";

export function switchLanguage(locale) {
  return {
    type: SWITCH_LANGUAGE,
    payload: locale,
  };
}

export function toggleCollapsedNav(isNavCollapsed) {
  return {
    type: TOGGLE_COLLAPSED_NAV,
    payload: isNavCollapsed,
  };
}

export function toggleCollapsedLang(isLangCollapsed) {
  return {
    type: TOGGLE_COLLAPSED_LANG,
    payload: isLangCollapsed,
  };
}

export function toggleCollapsedMemberMenu(isMemberMenuCollapsed) {
  return {
    type: TOGGLE_COLLAPSED_MEMBER_MENU,
    payload: isMemberMenuCollapsed,
  };
}

export function setMenuFooter(isActive) {
  return {
    type: SET_MENU_FOOTER_ACTIVE,
    payload: isActive,
  };
}

export function collapsedAllMenu() {
  return {
    type: COLLAPSED_ALL_MENU,
  };
}
